import { mapLadderPercentageTypeToPicksInfo } from "../../../constants";
const getPicksInfoDescription = (picksInfo, dict) => picksInfo === 1 ? dict.myBetsDictionary.Pick : dict.myBetsDictionary.Picks;
export function mapBoostsForModalInfo(percentageLadder, boostSelections, originalBoostSelections, dictionary) {
    const sortedPercentageLadder = percentageLadder
        .slice()
        .sort((a, b) => {
        const aNumberOfPicks = mapLadderPercentageTypeToPicksInfo[a.type];
        const bNumberOfPicks = mapLadderPercentageTypeToPicksInfo[b.type];
        return bNumberOfPicks - aNumberOfPicks;
    });
    const matchedBoostIndex = sortedPercentageLadder.findIndex(percentageStep => mapLadderPercentageTypeToPicksInfo[percentageStep.type] === boostSelections);
    const originalBoostIndex = sortedPercentageLadder.findIndex(percentageStep => mapLadderPercentageTypeToPicksInfo[percentageStep.type] === originalBoostSelections);
    return sortedPercentageLadder
        .map((ladderStep, index) => {
        const picksInfo = mapLadderPercentageTypeToPicksInfo[ladderStep.type];
        const isSelectedPick = picksInfo === boostSelections;
        return {
            picks: `${picksInfo} ${getPicksInfoDescription(picksInfo, dictionary)}`,
            boost: `${ladderStep.percentage}%`,
            isSelected: isSelectedPick,
            isOriginal: matchedBoostIndex > -1 && originalBoostIndex === index && ladderStep.percentage > sortedPercentageLadder[matchedBoostIndex].percentage && ladderStep.percentage === sortedPercentageLadder[originalBoostIndex].percentage,
        };
    });
}
//# sourceMappingURL=mapBoostsForModalInfo.js.map